import { useController, UseControllerProps } from "react-hook-form";
import React, { FC } from "react";
import { CheckboxProps, FormControl, FormHelperText } from "@mui/material";
import Checkbox from "./components/Checkbox";

export type TCheckboxProp = {
  name: string;
  label?: string | React.ReactNode;
  handleChange?: (value: boolean) => void;
  rules?: UseControllerProps["rules"];
};

const CheckboxControl: FC<CheckboxProps & TCheckboxProp> = ({ sx, name, label, disabled, handleChange, rules }) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name, defaultValue: false, rules });
  return (
    <FormControl error={!!error}>
      <Checkbox
        sx={sx}
        label={label}
        handleChange={(checked) => {
          onChange(checked);
          handleChange?.(checked);
        }}
        value={value}
        disabled={disabled}
      />
      {error?.message && <FormHelperText>{error.message}</FormHelperText>}
    </FormControl>
  );
};

export default CheckboxControl;
